import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "box", "dot"]
  static values = {
    checked: Boolean,
    variant: String
  }

  connect() {
    this.updateUI()
  }

  toggle() {
    this.checkedValue = this.inputTarget.checked
    this.updateUI()

    // Uncheck other radio buttons in the same group
    const radioName = this.inputTarget.name
    const allRadios = document.querySelectorAll(`input[type="radio"][name="${radioName}"]`)

    allRadios.forEach(radio => {
      if (radio !== this.inputTarget) {
        radio.checked = false
        // Find the controller instance for this radio and update its UI
        const controllerElement = radio.closest('[data-controller~="admin-radio"]')
        if (controllerElement) {
          const controller = this.application.getControllerForElementAndIdentifier(controllerElement, "admin-radio")
          if (controller) {
            controller.updateUI()
          }
        }
      }
    })
  }

  updateUI() {
    const isChecked = this.inputTarget.checked

    if (this.variantValue === "default") {
      if (isChecked) {
        this.boxTarget.classList.add("border-primary")
        this.dotTarget.classList.add("!bg-primary")
        this.dotTarget.classList.remove("bg-transparent")
      } else {
        this.boxTarget.classList.remove("border-primary")
        this.dotTarget.classList.remove("!bg-primary")
        this.dotTarget.classList.add("bg-transparent")
      }
    } else if (this.variantValue === "filled") {
      if (isChecked) {
        this.boxTarget.classList.add("!border-4")
      } else {
        this.boxTarget.classList.remove("!border-4")
      }
    }
  }
}
